import React from 'react';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { services } from '../mock';

export const Services = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-slate-50 to-white py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
              Comprehensive Waterproofing Solutions
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Professional solutions for every waterproofing need, from residential homes to large-scale infrastructure.
            </p>
          </div>
        </div>
      </section>

      {/* Services Detail */}
      <section className="py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16">
            {services.map((service, index) => (
              <div
                key={service.id}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <h2 className="text-3xl font-bold text-slate-900 mb-4">{service.title}</h2>
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-sm font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                        Problem We Solve
                      </h3>
                      <p className="text-base text-slate-600 leading-relaxed">{service.problem}</p>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                        Our Method
                      </h3>
                      <p className="text-base text-slate-600 leading-relaxed">{service.method}</p>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                        Long-term Benefit
                      </h3>
                      <div className="flex items-start space-x-3">
                        <CheckCircle2 className="w-5 h-5 text-slate-700 mt-0.5 flex-shrink-0" />
                        <p className="text-base text-slate-600 leading-relaxed">{service.benefit}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`rounded-lg overflow-hidden shadow-lg h-80 ${
                  index % 2 === 1 ? 'lg:order-1' : ''
                }`}>
                  <img 
                    src={service.imageUrl}
                    alt={service.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-slate-800 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
            Need Expert Waterproofing Advice?
          </h2>
          <p className="text-lg text-slate-300 mb-8">
            Get a free consultation and site inspection from our experienced team.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-4 bg-white text-slate-800 rounded-lg text-base font-semibold hover:bg-slate-100 transition-colors"
          >
            Schedule Inspection
            <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </section>
    </div>
  );
};